import React, {useState} from 'react'

import { Images } from '../../constants'
import { AppWrap, MotionWrap } from '../../wrapper'
import { client } from '../../client'


import "./Footer.scss"
const Footer = () => {
  const [FormData, setFormData] = useState({name:'', email:'',message:''})
  const [IsFormSubmitted, setIsFormSubmitted] = useState(false)
  const [Loading, setLoading] = useState(false)

  const {username, email, message} = FormData;

  const handleChangeInput = (e)=> {

    const {name, value } = e.target
    setFormData({...FormData, [name]:value})
  }

  const handleSubmit = ()=>{
    setLoading(true)

    const contact = {
      _type :'contact',
      name:FormData.username,
      email:FormData.email,
      message:FormData.message

    }

    client.create(contact).then(()=>{
      setLoading(false)
      setIsFormSubmitted(true)
    }).catch((err) => console.log(err));
  }

  return (
    <>
        <h2 className='head-text' >
          Feel free to start chatting 
        </h2>

        <div className='app__footer-cards'>
              <div className='app__footer-card'>
                  <img src={Images.email} alt='email'/>
                  <a href="mailto:mehrdadrahmatiiii@gmail.com" className='p-text'>mehrdadrahmatiii@gmail.com</a>
              </div>

              <div className='app__footer-card'>
                  <img src={Images.mobile} alt='mobile'/>
                  <a href="tel: +98 9184141579" className='p-text'>+98 9184141579</a>
              </div>
        </div>

        {!IsFormSubmitted ? 
        <div className='app__footer-form app__flex'>
            <div className='app__flex'>
              <input className='p-text' type='text' name='name' placeholder='Your Name' value={username} onChange={handleChangeInput}/>
            </div>

            <div className='app__flex'>
              <input className='p-text' type='email' name='email' placeholder='Your Email' value={email} onChange={handleChangeInput}/>
            </div>

            <div>
              <textarea
                className='p-text'
                placeholder='Your Message'
                name="message"
                value={message}
                onChange={handleChangeInput}

              />
            </div>
            <button type='button' className='p-text' onClick={handleSubmit}>{!Loading ? 'Send Message' :'Sending' }</button>
      </div>
        : (
          <div>
            <h3 className='head-text'>Tnx for getting in touch!</h3>
          </div>
        )}
    </>
  )
}

export default AppWrap(
  MotionWrap(Footer,'app__footer'), 
  'contact',
  'app__primarybg'
  )